import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IoClose } from 'react-icons/io5';
import s from './style.css';
import { FileViewItem } from '../../components';
import { vault } from '../../actions';
import { createFilesList } from '../../utils';
import ContextMenu from '../../components/ContextMenu';
const FileView = (props) => {
    const handleKeydown = (event) => {
        if (!props.visible)
            return;
        if (props.currentIndex < props.files.length - 1 && event.key === 'ArrowRight')
            props.fileViewScroll(event.key);
        if (props.currentIndex > 0 && event.key === 'ArrowLeft')
            props.fileViewScroll(event.key);
    };
    const [contextMenuVisible, setContextMenuVisible] = useState(false);
    const [contextMenuPosition, setContextMenuPosition] = useState({ x: 0, y: 0 });
    const [contextItem, setContextItem] = useState(null);
    const handleMenuItemClick = () => {
        setContextMenuVisible(false);
    };
    const handleCloseContextMenu = () => {
        setContextMenuVisible(false);
    };
    const handleContextMenu = (e, item) => {
        e.preventDefault();
        setContextMenuVisible(true);
        setContextMenuPosition({ x: e.clientX, y: e.clientY });
        setContextItem(item);
    };
    const handleEmptyClick = () => {
        setContextMenuVisible(false);
    };
    useEffect(() => {
        const keydownListener = (event) => handleKeydown(event);
        document.addEventListener('keydown', keydownListener);
        return () => {
            document.removeEventListener('keydown', keydownListener);
        };
    }, [props.files, props.currentIndex]);
    useEffect(() => {
        if (!props.file) {
            if (props.currentIndex > 0)
                props.fileViewScroll('ArrowLeft');
            else
                props.hideFileView();
        }
    }, [props.file]);
    if (!props.visible)
        return null;
    return (React.createElement("div", { className: s.container, onClick: handleEmptyClick, onKeyDown: (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                handleEmptyClick();
            }
        }, role: 'button', tabIndex: 0 },
        contextMenuVisible && (React.createElement(ContextMenu, { x: contextMenuPosition.x, y: contextMenuPosition.y, onItemClick: handleMenuItemClick, item: contextItem, type: 'file', inFileView: true })),
        React.createElement(IoClose, { size: 60, color: '#ffffff', className: s.close, onClick: () => props.hideFileView() }),
        props.file && (React.createElement(FileViewItem, { file: props.file, handleContextMenu: (e) => handleContextMenu(e, props.file) }))));
};
const mapStateToProps = (state) => {
    let file;
    let files = [];
    const { fileView } = state.appTemp;
    if (fileView.visible) {
        if (fileView.type === 'files') {
            const currentFolder = state.appTemp.isSearching
                ? { id: 'search' }
                : state.appTemp.folderStack[state.appTemp.folderStack.length - 1];
            const mostRecent = currentFolder.id === 'home' ? state.filesTree.mostRecent : null;
            files = createFilesList(state.filesTree[currentFolder.id] || [], mostRecent, state.files);
            file = files[fileView.index];
        }
        else if (fileView.type === 'photos') {
            files = Object.values(state.photos.recents || {});
            file = files[fileView.index];
        }
    }
    return {
        visible: state.appTemp.fileView.visible,
        file,
        files,
        currentIndex: state.appTemp.fileView.index,
    };
};
const connector = connect(mapStateToProps, { ...vault });
export default connector(FileView);
